import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

const POINTS = [
  "kas Jūsu kreatīvos jau ir izdarīts labi;",
  "kur tiek zaudēti pārdošanas akcenti;",
  "kāpēc kreatīvs var nesasniegt rezultātu;",
  "vai vizuālā hierarhija palīdz uztvert informāciju;",
  "ko konkrēti mēs ieteiktu mainīt.",
];

export default function Deliverables() {
  return (
    <section data-testid="deliverables-section" className="bg-[#F9F9F9] border-t border-black/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="text-xs font-semibold uppercase tracking-[0.3em] text-[#ED1C27]">Rezultāts</span>
              <h2 className="mt-4 font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-[#003E75]" data-testid="deliverables-heading">
                Ko Jūs{" "}
                <span className="text-[#003E75]/30">saņemsiet?</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-6">
              <p className="text-[#003E75]/60 text-base leading-relaxed max-w-md">
                Pēc audita Jūs saņemsiet strukturētu Jūsu baneru un/vai video profesionālu
                izvērtējumu. Rezultātā Jums būs konkrēts saraksts ar uzlabojumiem, ko var izmantot
                Jūsu iekšējā komanda, esošā aģentūra vai iMarketings.lv, ja uzsāksim sadarbību.
              </p>
              <p className="mt-5 text-[#003E75] font-semibold text-base max-w-md">
                Audits ir bez saistībām - Jūs varat pieņemt mūsu sadarbības piedāvājumu un varat noraidīt.
              </p>
            </Reveal>
          </div>

          <div className="space-y-3">
            <Reveal delay={0.05}>
              <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#003E75]/40 mb-2">Parādīsim:</p>
            </Reveal>
            {POINTS.map((p, i) => (
              <Reveal key={i} delay={0.08 + i * 0.05}>
                <div
                  data-testid={`deliverable-${i}`}
                  className="flex items-center gap-5 bg-white border border-black/15 rounded-sm px-6 py-5 hover:border-[#ED1C27] hover:-translate-y-0.5 transition-all duration-300"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#2EB789]/15">
                    <Check className="h-5 w-5 text-[#2EB789]" strokeWidth={3} />
                  </span>
                  <p className="text-[#003E75]/80 text-sm md:text-base">{p}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
